import ActionUtility from "../../utilities/ActionUtility";
import InfluencerPlatformEffect from "./InfluencerPlatformEffect";

export default class InfluencerPlatformAction {
  static REQUEST_INFLUENCER_PLATFORM =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_PLATFORM";
  static REQUEST_INFLUENCER_PLATFORM_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_PLATFORM_FINISHED";

  // facebook platform
  static REQUEST_INFLUENCER_FACEBOOKPLATFORM_POST =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_FACEBOOKPLATFORM_POST";
  static REQUEST_INFLUENCER_FACEBOOKPLATFORM_POST_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_FACEBOOKPLATFORM_POST_FINISHED";

  static REQUEST_INFLUENCER_FACEBOOKPLATFORM_PUT =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_FACEBOOKPLATFORM_PUT";
  static REQUEST_INFLUENCER_FACEBOOKPLATFORM_PUT_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_FACEBOOKPLATFORM_PUT_FINISHED";

  //instagram platform
  static REQUEST_INFLUENCER_INSTAGRAMPLATFORM_POST =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_INSTAGRAMPLATFORM_POST";
  static REQUEST_INFLUENCER_INSTAGRAMPLATFORM_POST_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_INSTAGRAMPLATFORM_POST_FINISHED";

  static REQUEST_INFLUENCER_INSTAGRAMPLATFORM_PUT =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_INSTAGRAMPLATFORM_PUT";
  static REQUEST_INFLUENCER_INSTAGRAMPLATFORM_PUT_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_INSTAGRAMPLATFORM_PUT_FINISHED";

  // youtube platform
  static REQUEST_INFLUENCER_YOUTUBEPLATFORM_POST =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_YOUTUBEPLATFORM_POST";
  static REQUEST_INFLUENCER_YOUTUBEPLATFORM_POST_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_YOUTUBEPLATFORM_POST_FINISHED";

  static REQUEST_INFLUENCER_YOUTUBEPLATFORM_PUT =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_YOUTUBEPLATFORM_PUT";
  static REQUEST_INFLUENCER_YOUTUBEPLATFORM_PUT_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_YOUTUBEPLATFORM_PUT_FINISHED";

  //quora platform

  static REQUEST_INFLUENCER_QUORAPLATFORM_POST =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_QUORAPLATFORM_POST";
  static REQUEST_INFLUENCER_YOUTUBEPLATFORM_POST_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_YOUTUBEPLATFORM_POST_FINISHED";

  static REQUEST_INFLUENCER_QUORAPLATFORM_PUT =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_QUORAPLATFORM_PUT";
  static REQUEST_INFLUENCER_QUORAPLATFORM_PUT_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_QUORAPLATFORM_PUT_FINISHED";

  // playstore platform

  static REQUEST_INFLUENCER_PLAYSTOREPLATFORM_POST =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_PLAYSTOREPLATFORM_POST";
  static REQUEST_INFLUENCER_PLAYSTOREPLATFORM_POST_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_PLAYSTOREPLATFORM_POST_FINISHED";

  static REQUEST_INFLUENCER_PLAYSTOREPLATFORM_PUT =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_PLAYSTOREPLATFORM_PUT";
  static REQUEST_INFLUENCER_PLAYSTOREPLATFORM_PUT_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_PLAYSTOREPLATFORM_PUT_FINISHED";

  // twitter platform

  static REQUEST_INFLUENCER_TWITTERPLATFORM_POST =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_TWITTERPLATFORM_POST";
  static REQUEST_INFLUENCER_TWITTERPLATFORM_POST_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_TWITTERPLATFORM_POST_FINISHED";

  static REQUEST_INFLUENCER_TWITTERLATFORM_PUT =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_TWITTERLATFORM_PUT";
  static REQUEST_INFLUENCER_TWITTERLATFORM_PUT_FINISHED =
    "InfluencerPlatformAction.REQUEST_INFLUENCER_TWITTERLATFORM_PUT_FINISHED";

  static requestInfluencerPlatforms(params) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_PLATFORM,
        InfluencerPlatformEffect.requestInfluencerPlatforms,
        params
      );
    };
  }

  static requestPostInfluencerFacebookAccount(data) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_FACEBOOKPLATFORM_POST,
        InfluencerPlatformEffect.requestPostInfluencerFacebookAccount,
        data
      );
    };
  }

  static requestPostInfluencerInstagramAccount(data) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_INSTAGRAMPLATFORM_POST,
        InfluencerPlatformEffect.requestPostInfluencerInstagramAccount,
        data
      );
    };
  }

  static requestPostInfluencerYoutubeAccount(data) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_YOUTUBEPLATFORM_POST,
        InfluencerPlatformEffect.requestPostInfluencerYoutubeAccount,
        data
      );
    };
  }

  static requestPutInfluencerFacebookAccount(data, id) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_FACEBOOKPLATFORM_PUT,
        InfluencerPlatformEffect.requestPutInfluencerFacebookAccount,
        data,
        id
      );
    };
  }

  static requestPutInfluencerInstagramAccount(data, id) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_INSTAGRAMPLATFORM_PUT,
        InfluencerPlatformEffect.requestPutInfluencerInstagramAccount,
        data,
        id
      );
    };
  }

  static requestPutInfluencerYoutubeAccount(data, id) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_YOUTUBEPLATFORM_PUT,
        InfluencerPlatformEffect.requestPutInfluencerYoutubeAccount,
        data,
        id
      );
    };
  }

  static requestPostInfluencerQuoraAccount(data) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_YOUTUBEPLATFORM_POST,
        InfluencerPlatformEffect.requestPostInfluencerQuoraAccount,
        data
      );
    };
  }

  static requestPutInfluencerQuoraAccount(data, id) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_QUORAPLATFORM_PUT,
        InfluencerPlatformEffect.requestPutInfluencerQuoraAccount,
        data,
        id
      );
    };
  }

  //playstore platform
  static requestPostInfluencerPlaystoreAccount(data) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_PLAYSTOREPLATFORM_POST,
        InfluencerPlatformEffect.requestPostInfluencerPlaystoreAccount,
        data
      );
    };
  }

  static requestPutInfluencerPlaystoreAccount(data, id) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_PLAYSTOREPLATFORM_PUT,
        InfluencerPlatformEffect.requestPutInfluencerPlaystoreAccount,
        data,
        id
      );
    };
  }

  //twitter platform
  static requestPostInfluencerTwitterAccount(data) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_TWITTERPLATFORM_POST,
        InfluencerPlatformEffect.requestPostInfluencerTwitterAccount,
        data
      );
    };
  }

  static requestPutInfluencerTwitterAccount(data, id) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        InfluencerPlatformAction.REQUEST_INFLUENCER_TWITTERLATFORM_PUT,
        InfluencerPlatformEffect.requestPutInfluencerTwitterAccount,
        data,
        id
      );
    };
  }
}
